import { FormCheck } from "react-bootstrap";

export function BindableFormCheck(props) {
	let { bindObject, bindAttribute, ...passableProps } = props;
	let updateFunc = (evt) => {
		bindObject[bindAttribute] = evt.target.checked;
	};
	return <FormCheck onClick={updateFunc} defaultChecked={bindObject? bindObject[bindAttribute] : false } {...passableProps} />
}